<div class="pageWrapper">
  <div class="formsDetails rfq">
    <section class="rfq-upper-section">
      <h3 class="page-title">Order Management</h3>
      <div class="searchBox-section">
        <div
          class="rfq-card-total"
          [ngClass]="{ 'tab-bg': currentTab !== OrderStatus.ACTIVE }"
          (click)="getOmsList(OrderStatus.ACTIVE, 0, 10)"
        >
          EDP Plan
          <span class="badge-notfication align-items-center" *ngIf="totalActiveOms > 0">{{ totalActiveOms }}</span>
        </div>

        <div
          class="rfq-card-total"
          [ngClass]="{ 'tab-bg': currentTab !== OrderStatus.IN_PROGRESS }"
          (click)="getOmsList(OrderStatus.IN_PROGRESS, 0, 10)"
        >
          Order In Progress
          <span class="badge-notfication align-items-center" *ngIf="totalInProgressOms > 0">{{ totalInProgressOms }}</span>
        </div>

        <div
          class="rfq-card-total"
          [ngClass]="{ 'tab-bg': currentTab !== OrderStatus.COMPLETED }"
          (click)="getOmsList(OrderStatus.COMPLETED, 0, 10)"
        >
          Order Completed
          <span class="badge-notfication align-items-center" *ngIf="totalCompletedOms > 0">{{ totalCompletedOms }}</span>
        </div>

        <form class="searchBox">
          <mat-icon class="iconColor">search</mat-icon>
          <input type="text" class="searchBox-input" (input)="searchOmsBy($event)" placeholder="Search by name" #textSearch />
          <span class="clear-icon" *ngIf="textSearch.value" (click)="textSearch.value = ''; clearTextSearch()"
            ><mat-icon>clear</mat-icon></span
          >
        </form>
        <!-- <button mat-icon-button class="searchBox-filter-icon">
          <mat-icon>tune</mat-icon>
        </button> -->
      </div>

      <div class="saved-rfq-button">
        <div class="sort_by">
          <button mat-button class="sort_by_btn" [matMenuTriggerFor]="menu">
            Filter By
            <span class="accodianBtn">
              <!-- <mat-icon>expand_more</mat-icon> -->
              <lucide-icon name="ChevronDown" class="icon"></lucide-icon>
            </span>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="filterBy('', 'allOrder')">All</button>
            <button mat-menu-item (click)="filterBy(EDPStatus.EDP_PENDING)">EDP Pending</button>
            <button mat-menu-item (click)="filterBy(EDPStatus.EDP_APPROVED)">EDP Approved</button>
            <button mat-menu-item (click)="filterBy(EDPStatus.EDP_RETURN)">EDP Returned</button>
            <button mat-menu-item (click)="filterBy(EDPStatus.EDP_RECEIVED)">EDP Received</button>
          </mat-menu>
        </div>
      </div>
    </section>
    <div>
      <div>
        <div class="rfq_lst_dtl">
          <mat-card class="rfq-card" *ngFor="let data of getOms">
            <div class="oms-card-top flex">
              <div class="flex">
                <span class="oms-po-id">P.O ID : </span>
                <span class="po-id">{{ data?.poId }}</span>
                <span class="po-template">{{ data?.rfqTemplateType }}</span>
              </div>

              <div class="flex">
                <span class="oms-status" [class]="data?.customerEdp?.edpStatus">{{ getEdpStatusLabel(data?.customerEdp?.edpStatus) }}</span>
              </div>
            </div>
            <mat-card-header>
              <div class="rfq-title-expiry col-sm-4">
                <mat-card-title class="matToolCss" matTooltip="{{ data?.projectName }}"> {{ data?.projectName }}</mat-card-title>
                <mat-card-subtitle>
                  <span class="small-font">Order Date : </span>
                  <span class="light-font"> {{ data?.orderDate }} </span>
                </mat-card-subtitle>
              </div>
              <div class="rfq-capabilities col-sm-4">
                <h5 class="rfq-category cate">Category</h5>
                <ng-container *ngFor="let cat of (data?.categories | categoryFormatter: 2).display">
                  <span class="capability" [matTooltip]="(data?.categories | categoryFormatter: 2).tooltip">
                    {{ cat }}
                  </span>
                </ng-container>
              </div>
              <div class="rfq-capabilities col-sm-4">
                <h5 class="rfq-category cate">Total Quantity</h5>
                <h5 class="rfq-category">{{ data?.totalQuantity }}</h5>
              </div>
            </mat-card-header>
            <div class="flex detail_box">
              <div class="rfq-capabilities col-sm-4">
                <h5 class="rfq-category cate">Due Date</h5>
                <h5 class="rfq-category due-date">
                  {{ data?.dueDate | date: "MMM d, y" }}
                </h5>
              </div>
              <div class="rfq-capabilities col-sm-4">
                <h5 class="rfq-category cate">Start Date</h5>
                <h5 class="rfq-category due-date">
                  {{ data?.startDate | date: "MMM d, y" }}
                </h5>
              </div>
              <div class="col-sm-4 flex justify-content-between">
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">End Date</h5>
                  <h5 class="rfq-category due-date">
                    {{ data?.endDate | date: "MMM d, y" }}
                  </h5>
                </div>
                <div class="rfq-view flex" *ngIf="data.customerEdp.edpStatus !== EDPStatus.EDP_PENDING">
                  <button mat-icon-button [routerLink]="getEdpRoute(data?.id)">
                    <!-- <mat-icon>keyboard_arrow_right</mat-icon> -->
                    <lucide-icon name="ChevronRight" class="icon"></lucide-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-card>
          <div class="no-result-container" *ngIf="getOms?.length == 0">
            <p>No Result Found</p>
          </div>
        </div>
        <div *ngIf="currentTab == OrderStatus.ACTIVE">
          <mat-paginator
            [length]="totalActiveOms"
            [pageSize]="pageSizeActive"
            [pageSizeOptions]="PAGE_SIZE_OPTIONS"
            (page)="onPageChangeActiveOms($event)"
          >
          </mat-paginator>
        </div>

        <div *ngIf="currentTab == OrderStatus.COMPLETED">
          <mat-paginator
            [length]="totalCompletedOms"
            [pageSize]="pageSizeCompleted"
            [pageSizeOptions]="PAGE_SIZE_OPTIONS"
            (page)="onPageChangeCompletedOms($event)"
          >
          </mat-paginator>
        </div>

        <div *ngIf="currentTab == OrderStatus.IN_PROGRESS">
          <mat-paginator
            [length]="totalInProgressOms"
            [pageSize]="pageSizeInProgress"
            [pageSizeOptions]="PAGE_SIZE_OPTIONS"
            (page)="onPageChangeInProgressOms($event)"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
